import builder from '../builder';
import Hyperlink3 from '../../streamline-icons/light/hyperlink-3.svg';

export default builder('IconHyperlink3Light', Hyperlink3);
